module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Deleted-folder-f0a7dfb116a4d5c9848d494974bdd4a8.svg";